import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import NavBreadcrum from "components/NavBreadcrum";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import FormOrganization from "./organizations/FormOrganization";
import { SwalAlertClass } from "core/swalClass";
import navs from "./navs";
import axiApi from "ApiCaller";


const ViewOrganizations = () => {
    const [t] = useTranslation("routes");
    const [urlQuery] = useSearchParams();
    const title = t("labels.organizations");
    const bread = [
        { name: t("labels.administration"), url: "/administration", current: false },
        { name: t("labels.organizations"), current: true }
    ];
    const Alert = new SwalAlertClass({ confirmButtonText: "Aceptar" });
    const [items, setItems] = useState([]);
    const [activeTab, setActiveTab] = useState(null);

    const QueryParams = () => {
        if (urlQuery.has("orgToken") && items.length > 0) {
            const orgToken = urlQuery.get("orgToken");
            // Verificar si el token es existe
            const orgExists = items.some(org => org.token === orgToken);

            if (orgExists) {
                setActiveTab(orgToken);
            } else {
                // esta mal token
                setActiveTab(items[0].token);
            }
        } else if (items.length > 0) {
            // defecto primero
            setActiveTab(items[0].token);
        }
    };

    useEffect(() => {
        document.title = title;

        axiApi.get("/api/organizations/")
            .then((r) => {
                if (r.data.status) {
                    setItems(r.data.items);
                    // No seleccionamos la pestaña aquí, lo haremos cuando procesemos los query parameters
                } else {
                    Alert.warning("Error al pedir datos", r.data.message);
                }
            })
            .catch((error) => {
                Alert.warning("Error en FormOrganization.api.get", error);
            });
    }, []);

    useEffect(() => {
        QueryParams();
    }, [items, urlQuery]);

    return (
        <>
            <NavBreadcrum navs={navs} bread={bread} />
            <div className="col-12">
                <h3>{t("labels.organizations")}</h3>
            </div>
            <Tabs
                activeKey={activeTab}
                onSelect={(k) => setActiveTab(k)}
                id="organizations-tabs"
                className="mb-3"
            >
                {
                    items.map((org, idx) =>
                        <Tab eventKey={org.token} title={org.name} key={idx}>
                            <FormOrganization item={org} />
                        </Tab>
                    )
                }
            </Tabs>
        </>
    );
};

export default ViewOrganizations;